export default __webpack_public_path__ + "static/media/hexowatch-logo.c9341063.svg";